<template>
  <section v-if="event.summary" class="event-section summary-section">
    <v-container>
      <p class="section-kicker">{{ kicker }}</p>
      <h2>{{ heading }}</h2>
      <div v-if="event.summaryParagraphs && event.summaryParagraphs.length" class="summary-copy">
        <p v-for="paragraph in event.summaryParagraphs" :key="paragraph">{{ paragraph }}</p>
      </div>
      <p v-else class="summary-copy">{{ event.summary }}</p>
      <div v-if="purpose" class="purpose-card">
        <strong>Why we went</strong>
        <span>{{ purpose }}</span>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'EventSummary',
  props: {
    event: { type: Object, required: true },
    heading: { type: String, default: 'The Story at a Glance' },
    kicker: { type: String, default: 'Overview' },
    purpose: { type: String, default: '' },
  },
};
</script>

<style scoped>
.event-section { background: #090909; padding: 72px 0; }
.section-kicker { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; letter-spacing: 0.12em; margin: 0 0 10px; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2rem, 5vw, 3.4rem); line-height: 1; margin: 0 0 22px; }
.summary-copy { color: #d4d4d4; font-size: clamp(1.12rem, 2vw, 1.35rem); line-height: 1.7; max-width: 900px; }
.summary-copy p { margin: 0; }
.summary-copy p + p { margin-top: 16px; }
.purpose-card { border-left: 3px solid #f0b13c; color: #c9c9c9; display: grid; gap: 7px; margin-top: 28px; max-width: 900px; padding: 4px 0 4px 20px; }
.purpose-card strong { color: #fff; font-family: "Oswald", sans-serif; text-transform: uppercase; }
.purpose-card span { line-height: 1.65; }
</style>
